import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  box: {
    width: '100%',
  },
  boxTitle: {
    fontSize: 20,
    fontWeight: 500,
    // marginBottom: '2px',
    textAlign: 'center',
  },
  boxSubTitle: {
    fontSize: 16,
    fontWeight: 400,
    // marginBottom: '20px',
    textAlign: 'center',
  },
  paper: {
    backgroundColor: '#ffffff',
    padding: '40px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    width: '100%',
    maxWidth: '600px',
    margin: '20px auto',
    borderRadius: '8px',
  },
  rowWide: {
    position: 'relative',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(2),
  },
  row: {
    position: 'relative',
    alignItems: 'center',
    marginBottom: '20px',
  },
  rowRadio: {
    position: 'relative',
    alignItems: 'center',
    marginBottom: '10px',
  },
  title: {
    margin: theme.spacing(0, 3.5, 0, 0),
    fontSize: 14,
    letterSpacing: 0.15,
    color: 'rgb(0 0 0 / 54%)',
  },
  input: {
    width: 'calc(100%)',
    color: 'rgb(0 0 0 / 87%)',
  },
  inputError: {
    width: 'calc(100%)',
    color: 'rgb(0 0 0 / 87%)',
    marginBottom: theme.spacing(-2.8),
    '& label': {
      transform: 'translate(0, 0)',
      '& + div': {
        margin: 0,
      },
    },
  },
  btnBox: {
    display: 'flex',
    justifyContent: 'flex-start',
  },
  btn: {
    padding: theme.spacing(1, 2),
    fontSize: 14,
    textTransform: 'none',
  },
  btnWide: {
    padding: theme.spacing(1, 5),
    fontSize: 14,
    textTransform: 'none',
  },
  btnWideLeft: {
    // padding: theme.spacing(1, 5),
    fontSize: 14,
    textTransform: 'none',
    // marginRight: 10,
  },
  imgBox: {
    width: 136,
    padding: 0,
  },
  fieldsBox: {
    width: 'calc(100% - 140px)',
    paddingLeft: theme.spacing(4),
    paddingRight: 0,
  },
  tableBox: {
    width: '100%',
    padding: 0,
  },
  userImg: {
    width: 136,
    height: 136,
    background: 'linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #2196F3',
    borderRadius: 8,
    marginBottom: theme.spacing(2),
    overflow: 'hidden',
  },
  actionBox: {
    position: 'absolute',
    right: 0,
  },
  halfSizeRow: {
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(3.5),
  },
  link: {
    //alignItems: 'flex-grow',
    marginLeft: theme.spacing(7),
    display: 'flex',
    alignItems: 'flex-end',
    color: '#737373',
  },
  recaptcha: {
    transform: 'scale(1)',
    transformOrigin: '0 0',
  },
  captcha: {
    margin: '0 auto',
    display: 'table',
  },
  button: {
    width: '100%',
    marginTop: '20px',
    boxShadow: 'none',
    textTransform: 'none',
    lineHeight: '36px',
    padding: `12px 22px`,
    backgroundColor: '#E2222B',
    fontSize: '16px',
    fontWeight: 600,
    '&:hover': {
      backgroundColor: '#c51e26',
    },
  },
  buttonGrp: {
    width: '48%',
    margin: '20px 1% 0 1%',
    boxShadow: 'none',
    textTransform: 'none',
    lineHeight: '36px',
    padding: `8px 22px`,
  },
  buttonGrpSecondary: {
    width: '48%',
    margin: '20px 1% 0 1%',
    boxShadow: 'none',
    textTransform: 'none',
    lineHeight: '36px',
    padding: `8px 22px`,
    border: '1px solid rgba(0, 0, 0, 0.23)',
    borderRadius: '4px',
  },
  circle: {
    width: '24px',
    height: '24px',
    color: 'white',
    backgroundColor: '#5081FF',
    borderRadius: '50%',
    marginRight: '15px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '166%',
  },
  disabledCircle: {
    width: '24px',
    height: '24px',
    color: 'white',
    backgroundColor: 'rgba(0, 0, 0, 0.38);',
    borderRadius: '50%',
    marginRight: '15px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '166%',
  },
  activeText: {
    fontWeight: 500,
    fontsize: '14px',
    lineHeight: '157%',
    letterspacing: '0.1px',
    color: 'rgba(0, 0, 0, 0.87)',
  },
  disabledText: {
    fontWeight: 400,
    fontsize: '14px',
    lineHeight: '157%',
    letterspacing: '0.1px',
    color: 'rgba(0, 0, 0, 0.54);es',
  },
  flex: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '23%',
  },
  hr: {
    alignSelf: 'center',
    background: 'black',
    width: '100%',
    height: '1px',
  },
  horizontalLine: {
    width: '50%',
    margin: '0 20px',
  },
  topBar: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    margin: '50px 0 0px 0',
  },
  icon: {
    fontSize: '14px',
  },
  radioLabel: {
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '150%',
    letterSpacing: '0.15px',
    color: 'rgba(0, 0, 0, 0.87)',
  },
  radioLink: {
    color: '#007DFF',
    textDecoration: 'underline',
  },
  emptyLink: {
    display: 'flex',
  },
  titles: {
    fontSize: 20,
    textAlign: 'center',
    width: '290px',
    color: 'black',
    display: 'block',
    margin: '10px auto',
  },

  container: {
    height: '100vh',
    background: `url(${Image}), linear-gradient(180deg, #FFFFFF -30.28%, #E2E6F7 161.33%)`,
    backgroundPosition: 'bottom, left top',
    backgroundRepeat: 'repeat-x, repeat',
    backgroundSize: 'contain, cover',
  },
  loginWithGoogleBtn: {
    transition: 'background-color 0.3s, box-shadow 0.3s',
    textTransform: 'uppercase',
    width: '100%',
    textAlign: 'center',
    padding: '12px 16px 12px 42px',
    border: 'none',
    borderRadius: '3px',
    boxShadow: '0 -1px 0 rgba(0, 0, 0, 0.04), 0 1px 1px rgba(0, 0, 0, 0.25)',
    color: 'rgba(71, 49, 185, 1)',
    fontSize: '14px',
    fontWeight: 500,
    backgroundImage:
      'url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMTcuNiA5LjJsLS4xLTEuOEg5djMuNGg0LjhDMTMuNiAxMiAxMyAxMiAxMyAxMy42djIuMmgzYTguOCA4LjggMCAwIDAgMi42LTYuNnoiIGZpbGw9IiM0Mjg1RjQiIGZpbGwtcnVsZT0ibm9uemVybyIvPjxwYXRoIGQ9Ik05IDE4YzIuNCAwIDQuNS0uOCA2LTIuMmwtMy0yLjJhNS40IDUuNCAwIDAgMS04LTIuOUgxVjEzYTkgOSAwIDAgMCA4IDV6IiBmaWxsPSIjMzRBODUzIiBmaWxsLXJ1bGU9Im5vbnplcm8iLz48cGF0aCBkPSJNNCAxMC43YTUuNCA1LjQgMCAwIDEgMC0zLjRWNUgxYTkgOSAwIDAgMCAwIDhsMy0yLjN6IiBmaWxsPSIjRkJCQzA1IiBmaWxsLXJ1bGU9Im5vbnplcm8iLz48cGF0aCBkPSJNOSAzLjZjMS4zIDAgMi41LjQgMy40IDEuM0wxNSAyLjNBOSA5IDAgMCAwIDEgNWwzIDIuNGE1LjQgNS40IDAgMCAxIDUtMy43eiIgZmlsbD0iI0VBNDMzNSIgZmlsbC1ydWxlPSJub256ZXJvIi8+PHBhdGggZD0iTTAgMGgxOHYxOEgweiIvPjwvZz48L3N2Zz4=)',
    backgroundColor: 'white',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: '60px center',
    '&:hover': {
      boxShadow: '0 -1px 0 rgba(0, 0, 0, 0.04), 0 2px 4px rgba(0, 0, 0, 0.25)',
    },
    '&:active': {
      backgroundColor: '#eeeeee',
    },
    '&:focus': {
      outline: 'none',
      boxShadow: '0 -1px 0 rgba(0, 0, 0, 0.04), 0 2px 4px rgba(0, 0, 0, 0.25), 0 0 0 3px #c8dafc',
    },
    '&:disabled': {
      filter: 'grayscale(100%)',
      backgroundColor: '#ebebeb',
      boxShadow: '0 -1px 0 rgba(0, 0, 0, 0.04), 0 1px 1px rgba(0, 0, 0, 0.25)',
      cursor: 'not-allowed',
    },
    '@media (max-width: 768px)': {
      padding: '12px 16px',
      backgroundPosition: '13px 14px',
      textAlign: 'center',
    },
  },
  borderClass: {
    backgroundColor: '#eee',
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    '&.Mui-focused': {
      '& .MuiOutlinedInput-notchedOutline': {
        border: 'none',
      },
    },
  },
}));
